<section class="listview-section" class="flex-1 flex-column gap-16">
  <div
    #listviewContainer
    class="colored-yarn-set-container"
    *ngFor="
      let productionSchedulePathsOfColoredYarnSet of productionSchedule.productionSchedulePathsOfColoredYarnSets;
      trackBy: trackProductionScheduleColoredYarnSet;
      let productionSchedulePathsOfColoredYarnSetIndex = index
    "
  >
    <mat-expansion-panel
      #expansionPanels
      *ngFor="
        let productionSchedulePath of productionSchedulePathsOfColoredYarnSet | getProductionScheduleColoredYarnSetPaths: productionSchedulePathsOfColoredYarnSetIndex : productionSchedule;
        trackBy: trackProductionSchedulePath;
        let productionSchedulePathIndex = index
      "
      [ngClass]="classNameForPath"
      [expanded]="true"
      [hideToggle]="true"
      [style.height.px]="getHeightForExpansionPanel(productionSchedulePath)"
    >
      <mat-expansion-panel-header class="path-header gap-8" collapsedHeight="40px" expandedHeight="40px">
        <mat-panel-title class="path-title gap-8">
          <h4 class="font-weight-bold">{{ productionSchedulePath.name }}</h4>
          <mat-divider vertical class="vertical-divider"></mat-divider>
        </mat-panel-title>

        <mat-panel-description class="flex-start-center gap-8">
          <div class="dimensions flex-column">
            <div class="flex-row gap-4">
              <div class="b2 font-weight-regular">{{ 'GENERAL.DIMENSIONS.WIDTH' | bmsTranslate }}:</div>
              <div class="b2 font-weight-semibold">
                {{ getUnitDimensionsForPathWidth(productionSchedulePath) }}
              </div>
            </div>
          </div>
          <div class="dimensions flex-column">
            <div class="flex-row gap-4">
              <div class="b2 font-weight-regular">{{ 'GENERAL.DIMENSIONS.LENGTH' | bmsTranslate }}:</div>
              <div class="b2 font-weight-semibold">
                {{ getUnitDimensionsForPathLength(productionSchedulePath) }}
              </div>
            </div>
          </div>
          <div class="dimensions flex-column">
            <div class="flex-row gap-4">
              <div class="b2 font-weight-regular">{{ 'PRODUCTION_ORDER.WEAVE_PLAN.WEAVE_PLAN_SUMMARY.PATH_LENGTH_DIFFERENCE' | bmsTranslate }}:</div>
              <div class="b2 font-weight-semibold">
                {{ getUnitDimensionsForDifference(productionSchedulePath) }}
              </div>
            </div>
          </div>
          <mat-divider vertical class="vertical-divider"></mat-divider>

          <app-color-list-preview-with-position
            #colorListPreviewComponents
            [isSisal]="productionSchedule.machine.jacquard.isSisal"
            [coloredYarnSet]="productionSchedulePathsOfColoredYarnSet.productionScheduleColoredYarnSet"
            (click)="$event.stopPropagation()"
            [creelMapping]="productionSchedule.mappingForCurrentPositionOnMachine ? this.productionSchedule.mappingForCurrentPositionOnMachine[productionSchedulePathsOfColoredYarnSetIndex] : null"
          ></app-color-list-preview-with-position>

          <div class="expand-icon-container">
            <mat-icon class="expand-icon" svgIcon="solid-expand-more"></mat-icon>
          </div>
        </mat-panel-description>
      </mat-expansion-panel-header>

      <ag-grid-angular
        #listViewGrids
        class="ag-theme-vdw full-width"
        [gridOptions]="gridOptionsForListView[productionSchedulePath.pathNumber]"
        [rowData]="productionSchedulePath.pathGroups"
      ></ag-grid-angular>
    </mat-expansion-panel>
  </div>
</section>
